(() => {
class SunartTrustStats extends HTMLElement {
  connectedCallback() {
    this.values = [...this.querySelectorAll('[data-stat-value]')];
    if (this.dataset.countupEnabled !== 'true' || !this.values.length) return;

    this.duration = Number.parseInt(this.dataset.countupDuration, 10) || 1200;
    this.parsedValues = this.values.map((element) => this.parseValue(element));

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.parsedValues.forEach((item) => {
      if (item) item.element.textContent = this.formatValue(item, 0);
    });

    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.animateValues();
      },
      { threshold: 0.3 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    if (this.frame) window.cancelAnimationFrame(this.frame);
  }

  parseValue(element) {
    const original = element.dataset.statValue || element.textContent.trim();
    const match = original.match(/-?\d[\d,]*(?:\.\d+)?/);
    if (!match) return null;

    const number = Number.parseFloat(match[0].replaceAll(',', ''));
    if (!Number.isFinite(number)) return null;

    return {
      element,
      target: number,
      decimals: match[0].includes('.') ? match[0].split('.')[1].length : 0,
      prefix: original.slice(0, match.index),
      suffix: original.slice((match.index || 0) + match[0].length),
    };
  }

  formatValue(item, value) {
    const formatted = value.toLocaleString(undefined, {
      minimumFractionDigits: item.decimals,
      maximumFractionDigits: item.decimals,
    });
    return `${item.prefix}${formatted}${item.suffix}`;
  }

  animateValues() {
    const start = performance.now();
    const tick = (now) => {
      const progress = Math.min(1, (now - start) / this.duration);
      const eased = 1 - Math.pow(1 - progress, 3);

      this.parsedValues.forEach((item) => {
        if (!item) return;
        item.element.textContent = this.formatValue(item, item.target * eased);
      });

      if (progress < 1) this.frame = window.requestAnimationFrame(tick);
    };
    this.frame = window.requestAnimationFrame(tick);
  }
}

if (!customElements.get('sunart-trust-stats')) {
  customElements.define('sunart-trust-stats', SunartTrustStats);
}
})();
